module.exports = __webpack_public_path__ + "media/headers/contactos-9341f0f3.png";